import { makeAutoObservable } from 'mobx'
import type { Phone } from 'entities/Phone/model/Phone'
import type { IParamsSendFrom } from 'entities/SendFrom'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { SendFromStore } from 'widgets/SendFrom'

export class CampaignSendFromStore {
  sendFromStore
  constructor(private _entities: IEntitiesStore) {
    this.sendFromStore = new SendFromStore(this._entities, {
      excludeDeprioritizedNumbers: true,
    })
    makeAutoObservable(this)
  }

  init = async (params: IParamsSendFrom) => {
    await this.sendFromStore.setSendFrom(params)
    if (this.number && this.error === 'Please select the inbox to send from') {
      this.setError('')
    }
  }

  get params() {
    return this.sendFromStore.paramsSendFrom
  }

  error = ''
  setError = (value: typeof this.error) => {
    this.error = value
  }

  get number(): Phone | undefined | null {
    const sendFrom = this.sendFromStore.paramsSendFrom
    if (!sendFrom) return

    if (sendFrom.options.number_id) {
      return this._entities.numbersStore.getItem(sendFrom?.options.number_id)
    }

    if (sendFrom.options.team_id) {
      const inbox = this._entities.inboxesStore.getItem(sendFrom.options.team_id)

      if (inbox && inbox.type === 'inbox') {
        const numberId = inbox?.sendingOptions?.find(
          (item) => item.key === sendFrom?.options?.smart_option
        )?.number_ids[0]

        return this._entities.numbersStore.getItem(numberId)
      }
    }
  }

  checkValidate = () => {
    let validate = true
    if (!this.params) {
      validate = false
      this.setError('Please select the inbox to send from')
    }
    return validate
  }
}
